import { BufferAttribute, BufferGeometry, DoubleSide, DynamicDrawUsage, Mesh, MeshBasicMaterial } from "three";
import { Vector3 } from "flavr-math";
const UNIT_Y = new Vector3(0, 1, 0);
const A = new Vector3();
const B = new Vector3();
const C = new Vector3();
const D = new Vector3();
export class RayCurveMesh extends Mesh {
    constructor(numPoints, width) {
        super(new BufferGeometry(), new MeshBasicMaterial({
            side: DoubleSide,
            transparent: true
        }));
        this.numPoints = numPoints;
        this.width = width;
        this.direction = new Vector3();
        this.frustumCulled = false;
        this.vertices = new Float32Array(this.numPoints * 3 * 6);
        this.geometry.setAttribute("position", new BufferAttribute(this.vertices, 3).setUsage(DynamicDrawUsage));
    }
    setDirection(direction) {
        this.direction
            .copy(direction)
            .cross(UNIT_Y)
            .normalize()
            .multiplyScalar(this.width / 2);
    }
    setPoint(point, i) {
        let idx = 3 * 6 * i;
        A.copy(point).add(this.direction);
        B.copy(point).sub(this.direction);
        C.set(
        // Previous A
        i === 0 ? A.x : this.vertices[idx - 3], i === 0 ? A.y : this.vertices[idx - 2], i === 0 ? A.z : this.vertices[idx - 1]);
        D.set(
        // Previous B
        i === 0 ? B.x : this.vertices[idx - 6], i === 0 ? B.y : this.vertices[idx - 5], i === 0 ? B.z : this.vertices[idx - 4]);
        //   A---P---B
        //   | \     |
        //   |  \    |
        //   |   \   |
        //   |    \  |
        //   |     \ |
        //   |      \|
        //   C-------D
        //   A'--P'--B' Previous P
        //   | \     |
        this.vertices[idx++] = A.x;
        this.vertices[idx++] = A.y;
        this.vertices[idx++] = A.z;
        this.vertices[idx++] = C.x;
        this.vertices[idx++] = C.y;
        this.vertices[idx++] = C.z;
        this.vertices[idx++] = D.x;
        this.vertices[idx++] = D.y;
        this.vertices[idx++] = D.z;
        this.vertices[idx++] = D.x;
        this.vertices[idx++] = D.y;
        this.vertices[idx++] = D.z;
        this.vertices[idx++] = B.x;
        this.vertices[idx++] = B.y;
        this.vertices[idx++] = B.z;
        this.vertices[idx++] = A.x;
        this.vertices[idx++] = A.y;
        this.vertices[idx++] = A.z;
        this.geometry.attributes.position.needsUpdate = true;
    }
    getMaterial() {
        return this.material;
    }
}
